export default __webpack_public_path__ + "static/media/analytics-payment-bg-dark.7a66af9f.png";